import React, {useEffect, useState} from "react";
import {useNavigate, Link, useLocation, useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import MainLayout from "../../../../commons/layout/MainLayout/index";
import HeaderHs2 from "../../../../commons/components/Header/headerHs2";
import API, {ROUTES} from "../../../../commons/api/api";
import {put} from "redux-saga/effects";
import * as actionCreators from "../../redux/actions";
import DialogComponent from "../../../../commons/components/Modal/DialogComponent";

import {hasWhiteSpace, validateEmail} from '../../../../utils/helpers';
import ROUTERS from "../../../../commons/constans/router";

import {formatPhoneNumber, generateUuid} from '../../../../utils/helpers'

import './_styles.scss';
import {repeat} from "redux-logger/src/helpers";
import CountDownTime from "../../../../commons/components/CountDownTime";
import Loading from "../../../../commons/components/Loading";
import InfoService from "../../../InformationService/components/InfoService";
import { v4 as uuidv4 } from 'uuid';

const RegisterComponent = ({type, loginRequest, resetState ,isProcessing}: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const [isShowInforModal, setIsShowInforModal] = useState(false);
    const [dataError, setDataError] = useState({});

    const [buttonSubmit, setButtonSubmit] = useState(false);

    const [loading, setLoading] = useState(false);

    const location = useLocation();

    const state = location.state;

    const [dataForm, setDataForm] = useState({
        fullname: "",
        phone: "",
        email: "",
        password_confirmation: '',
        password: '',
        agree: false,
        terms_of_service: false,
        privacy_policy: false,
        verify_code_phone_number: ''
    });

    // status : wait,waiting,done
    const [statusCheckPhoneNumber, setStatusCheckPhoneNumber] = useState('wait');

    //status : wait - done
    const [statusCheckEmail, setStatusCheckEmail] = useState('wait');

    // const [stateButtonVerifyPhoneNumber,setStateButtonVerifyPhoneNumber] = useState(false);

    const [dialogMessages, setDialogMessages] = useState({
        show: false,
        title: '',
        content: '',
        button: '',
    });

    const initMinutes = 4;
    const initSecond = 59;

    const [minutes, setMinutes] = useState(initMinutes);
    const [seconds, setSeconds] = useState(initSecond);

    const [serviceTerm,setServiceTerm] = useState([]);
    const [servicePolicy,setServicePolicy] = useState([]);

    const [typePage,setTypePage] = useState('register'); // register || term || policy

    const [popupConfirmRegisterEmail,setPopupConfirmRegisterEmail] = useState(false);

    const [popupRegisterSubmit,setPopupRegisterSubmit] = useState(false);


    useEffect(() => {
        if(popupConfirmRegisterEmail || popupRegisterSubmit){
            document.body.classList.add('overflow-hidden');
        }else{
            document.body.classList.remove('overflow-hidden');
        }
    },[popupRegisterSubmit,popupConfirmRegisterEmail]);

    const fetchDataService = async (type) =>{
        //ROUTES.API_INFORMATION_SERVICE+param+'&limit=1'
        try {
            const {data: response} = await API.get(`${ROUTES.API_INFORMATION_SERVICE}?type=${type}&limit=1`);
            switch (type) {
                case 'term' :
                    setServiceTerm(response?.data);
                    break;

                case 'policy':
                    setServicePolicy(response?.data);
                    break;
            }

        } catch (error) {
            console.error(error.message);
        }
    }

    useEffect(() => {

        if (state && state.dataForm) {
            setDataForm({
                ...state.dataForm,
                verify_code_phone_number: state.statusCheckPhoneNumber === 'done' ? state.dataForm.verify_code_phone_number : ''
            });

            if (state && state.statusCheckEmail === 'done') {
                setStatusCheckEmail('done');
            }

            if (state && state.statusCheckPhoneNumber === 'done') {
                setStatusCheckPhoneNumber('done');
            }

            navigate(location.pathname, {replace: true});
        }

        fetchDataService('term')
        fetchDataService('policy')

    }, []);

    useEffect(() => {
        if (dataForm.phone &&
            dataForm.phone && dataForm.email
            && dataForm.password_confirmation
            && dataForm.password && dataForm.agree
            && dataForm.terms_of_service
            && dataForm.privacy_policy
            && statusCheckPhoneNumber === 'done'
            && statusCheckEmail === 'done'
        ) {
            setButtonSubmit(true)
        } else {
            setButtonSubmit(false)
        }

    }, [dataForm, statusCheckPhoneNumber, statusCheckEmail, statusCheckEmail]);

    useEffect(() => {
        switch (type) {
            case "LOGIN_FAILD":
                dispatch(resetState());
                break;
        }
    }, [type]);

    useEffect(() => {
        window.scrollTo(0, 0)
        var idRegister = document.getElementById("register-page");
        var idService = document.getElementById("information");
        switch (typePage) {
            case 'register':
                idService.classList.add("d-none");
                idRegister.classList.remove("d-none");
                break;
            default:
                idRegister.classList.add("d-none");
                idService.classList.remove("d-none");
                break;
        }
    }, [typePage]);

    const _handleSubmitForm = (registerConfirm = '') => { //registerConfirm : email_confirm, register_confirm, ''

        console.log('_handleSubmitForm');
        if(statusCheckEmail !== 'done'){ //check agree email
            setDialogMessages({
                show: true,
                title: '알림',
                content: `<p class="warning-text">이메일 중복확인이 필요합니다.</p>`,
                button: '확인',
            })
            return;
        }

        if(registerConfirm){
            dataForm.register_confirm = 'register_confirm'
        }else{
            dataForm.register_confirm = ''
        }

        setButtonSubmit(false)
        setLoading(true);
        API.post(ROUTES.API_REGISTER_USER, dataForm).then(res => {
            setLoading(false);
            setDataError({});
            //confirm register
            if(res && res.data && res.data.register_confirm){
                if(registerConfirm === 'email_confirm') {
                    setPopupConfirmRegisterEmail(true);
                    return false;
                }
                setPopupConfirmRegisterEmail(false);
                return setPopupRegisterSubmit(true);
            }

            let data = res.data.data;
            let deviceKey = generateUuid();
            let dataLogin = {
                'email': dataForm.email,
                'password': dataForm.password,
                'remember_me': true,
                'user_version' : window.appDevice?.userVersion || '',
                'device_key' :  deviceKey || '',
                'fcm_token' : window.appDevice?.fcmToken || '',
                'sign_up': true
            }
            dispatch(loginRequest(dataLogin));
        }).catch(e => {
            setLoading(false);
            setButtonSubmit(true)
            let dataError = {};
            let errors = e.response;
            switch (errors.status) {
                case 422 :
                    if (errors.data && errors.data.errors) {
                        Object.keys(errors.data.errors).map(function (key, index) {
                            if (errors.data.errors[key][0] === '비밀번호가 일치하지 않습니다.') {
                                dataError['password_confirmation'] = errors.data.errors[key][0];
                            } else {
                                dataError[key] = errors.data.errors[key][0];
                            }

                        });
                        setDataError(dataError);
                    }
                    break;
            }
        })
    }

    const handleCancelRegister = () => {
        console.log('handleCancelRegister');
        setPopupConfirmRegisterEmail(false);
        setButtonSubmit(true);
    }

    const _onChangeInput = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === 'phone') {
            let valuePhoneNumber = value;
            valuePhoneNumber = value.replaceAll('-', '')
            if (valuePhoneNumber.length <= 11) {
                const re = /^[0-9\b]+$/;
                if (valuePhoneNumber === '' || re.test(valuePhoneNumber)) {
                    setDataForm({
                        ...dataForm,
                        [name]: formatPhoneNumber(valuePhoneNumber)
                    });


                    setStatusCheckPhoneNumber('wait');
                }
            }
            return false;
        } else if (name === 'agree' || name === 'terms_of_service' || name === 'privacy_policy') {

            if (name === 'agree') {
                return setDataForm({
                    ...dataForm,
                    [name]: value,
                    terms_of_service: value ? true : false,
                    privacy_policy: value ? true : false
                })
            }

            if (name === 'terms_of_service') {
                return setDataForm({
                    ...dataForm,
                    [name]: value,
                    agree: value && dataForm.privacy_policy ? true : false
                })
            }

            if (name === 'privacy_policy') {
                return setDataForm({
                    ...dataForm,
                    [name]: value,
                    agree: value && dataForm.terms_of_service ? true : false
                })
            }

            return setDataForm({
                ...dataForm,
                [name]: value
            });
        } else if (name === 'email') {
            setStatusCheckEmail('wait');
        }else if(name === 'password' || name === 'password_confirmation'){
            if(hasWhiteSpace(value)){
                return false;
            }

            if(value.length <= 20){
                setDataForm({
                    ...dataForm,
                    [name]: value
                });
            }
            return true;
        }

        setDataForm({
            ...dataForm,
            [name]: value
        })
    }

    const _handleCloseDialog = () => {
        setDialogMessages({
            ...dialogMessages,
            show: false
        });
    }

    const checkSendCodePhoneNumber = () => {
        let phone_number = dataForm.phone;
        //start check send code
        setLoading(true);
        API.post(`${ROUTES.API_SEND_CODE_PHONE_NUMBER}?type=sms`, {phone_number}).then(res => {
            setStatusCheckPhoneNumber('waiting');
            setMinutes(0);
            setSeconds(0);
            setMinutes(initMinutes);
            setSeconds(initSecond);
            setLoading(false);
            // setStateButtonVerifyPhoneNumber(false);// set disable button verify
        }).catch(e => {
            setLoading(false);
            let error = e.response;
            switch (error.status) {
                case 422 :
                    if (error.data && error.data.msg) {
                        setDialogMessages({
                            show: true,
                            title: '알림',
                            content: error.data.msg,
                            button: '확인',
                        })
                    }
                    break;
            }
        });
    }

    const _apiCheckValidate = (type, value) => {
        setLoading(true);
        API.post(ROUTES.API_CHECK_VALIDATE_USER, {type, value})
            .then(res => {
                setLoading(false);
                let message = '';
                switch (type) {
                    case 'email' :
                        // message = `<p class="email-text ">${value}으로 </p>  회원가입을 진행하시겠습니까? <p class="warning-text mt-2">! 가입된 이메일 주소는 변경이 불가능합니다.</p>`
                        message = `사용 가능한 이메일입니다.`;
                        setDialogMessages({
                            show: true,
                            title: '알림',
                            content: message,
                            button: '확인',
                        });
                        setStatusCheckEmail('done');
                        break;
                    case 'phone' :
                        setDataForm({
                            ...dataForm,
                            verify_code_phone_number: ''
                        })

                        checkSendCodePhoneNumber();
                        break;
                }
            }).catch(e => {
            setLoading(false);
            let errors = e.response;
            let message = '네트워크를 확인하십시오.';

            switch (type) {
                case 'email' :
                    if (errors.status === 422) {
                        Object.keys(errors.data.errors).map(function (key, index) {
                            message = `<p class="warning-text">${errors.data.errors[key][0]}</p>`;
                            if (errors.data.errors[key][0] === "등록된 이메일입니다.") {
                                message = `<p class="warning-text">이미 등록된 이메일입니다.</p> <p class="">이메일을 다시 확인해주세요.</p>`;
                            }
                        });
                    }
                    setStatusCheckEmail('wait');
                    break;
                case 'phone' :
                    if (errors.status === 422) {
                        Object.keys(errors.data.errors).map(function (key, index) {
                            message = `<p class="warning-text">${errors.data.errors[key][0]}</p>`;
                            if (errors.data.errors[key][0] === "이미 등록된 핸드폰 번호입니다.") {
                                message = `
                                    <p class="warning-text">이미 등록된 번호입니다.</p>
                                    <p class="">번호를 다시 확인해주세요.</p>
                                `;
                            }
                        });
                    }
                    // set lai validate phone
                    setStatusCheckPhoneNumber('wait');
                    break;
            }
            setDialogMessages({
                show: true,
                title: '알림',
                content: message,
                button: '확인',
            })
        })
    }

    const _checkValidate = (type) => {
        switch (type) {
            case 'email' :
                if (dataForm.email) {

                    if (!validateEmail(dataForm.email)) {
                        return setDialogMessages({
                            show: true,
                            title: '알림',
                            content: `
                                <p class="warning-text">이메일 주소를 잘못 입력하였습니다.</p>
                                <p class="warning-text">다시 확인해주세요.</p>
                            `,
                            button: '확인',
                        });
                    }
                    _apiCheckValidate(type, dataForm.email)
                }
                break;

            case 'phone' :
                if (dataForm.phone) {
                    _apiCheckValidate(type, dataForm.phone)
                }
                break;
        }
    }

    const verifyCodePhoneNumber = () => {
        let {verify_code_phone_number, phone} = dataForm;
        if (verify_code_phone_number) {
            setLoading(true);
            API.post(`${ROUTES.API_VERIFY_CODE_PHONE_NUMBER}?type=sms`, {
                phone_number: phone,
                code: verify_code_phone_number
            }).then(res => {
                setLoading(false);
                let message = `휴대폰 인증이 완료되었습니다.`;

                setDialogMessages({
                    show: true,
                    title: '알림',
                    content: message,
                    button: '확인',
                });

                setStatusCheckPhoneNumber('done');
                // setStateButtonVerifyPhoneNumber(true);// set disable button verify
                setMinutes(0)
                setSeconds(0)

            }).catch(e => {
                setLoading(false);
                let message = '<p class="warning-text">인증번호가 맞지 않습니다.</p>';
                setDialogMessages({
                    show: true,
                    title: '알림',
                    content: message,
                    button: '확인',
                });
            })
        }
    }

    const handleLabelLeft = () => {
        navigate(ROUTERS.LOGIN)
    }

    const contentDialog = () => {
        return {__html: dialogMessages.content}
    }

    const handleChangePage = (type) => {
        setTypePage(type)
    }



    return (
        <>
            <MainLayout
                pageID={"register-page"}
                displayBottomNav={false}
                isLoading={loading}
            >
                
                <HeaderHs2
                    title={"회원가입"}
                    labelLeft={true}
                    labelRight={false}
                    handleLabelLeft={handleLabelLeft}
                />
                <div className="wrapper mt-5">
                    {loading || isProcessing ? <Loading/> : ''}
                    <div className="container">
                        <div>
                            <div>
                                <div className="input-component">
                                    <label className="required">이름</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            placeholder="이름을 입력하세요."
                                            name={'fullname'}
                                            onChange={_onChangeInput}
                                            value={dataForm.fullname}
                                            autoComplete={'off'}
                                        />
                                    </div>
                                    {dataError.fullname ?
                                        <span className="input-error show">*{dataError.fullname}</span> : ''}
                                </div>
                                <div className="input-component">
                                    <label className="required">휴대폰번호</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="input-group__input_form"
                                            placeholder="(-)를 제외하고 입력해주세요. "
                                            name={'phone'}
                                            onChange={_onChangeInput}
                                            value={dataForm.phone}
                                            autoComplete={'off'}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-register register-page__custom-button-register-page-disable"
                                            onClick={() => _checkValidate('phone')}
                                            // status : wait,waiting,done
                                            disabled={statusCheckPhoneNumber === 'waiting' || statusCheckPhoneNumber === 'wait' || (statusCheckPhoneNumber === 'waiting' && minutes === 0 && seconds === 0) ? false : true}
                                        >
                                            {statusCheckPhoneNumber === 'wait' ? '인증' : '재발송'}
                                        </button>
                                        {dataError.phone ?
                                            <span className="input-error show">*{dataError.phone}</span> : ''}
                                    </div>
                                    {statusCheckPhoneNumber === 'waiting' || statusCheckPhoneNumber === 'done' ?
                                        <div className="input-group verification-code">
                                            <input
                                                type="text"
                                                className="input-group__input_form verification-code__position"
                                                placeholder="인증번호를 입력해주세요. "
                                                name={'verify_code_phone_number'}
                                                onChange={_onChangeInput}
                                                value={dataForm.verify_code_phone_number}
                                                autoComplete={'off'}
                                                disabled={statusCheckPhoneNumber === 'done' || (statusCheckPhoneNumber === 'waiting' && minutes === 0 && seconds === 0) ? true : false}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-outline-register register-page__custom-button-register-page-disable"
                                                onClick={verifyCodePhoneNumber}
                                                // waiting vs end minute = 0 second = 0 | statusCheckPhoneNumber = 'done'
                                                disabled={statusCheckPhoneNumber === 'done' || (statusCheckPhoneNumber === 'waiting' && minutes === 0 && seconds === 0) ? true : false}
                                                // autoComplete={'off'}
                                            >
                                                확인
                                            </button>
                                            <span className="time-count-down">
                                            {statusCheckPhoneNumber === 'done' ? '' : <CountDownTime
                                                minutes={minutes}
                                                seconds={seconds}
                                                setMinutes={setMinutes}
                                                setSeconds={setSeconds}
                                            />}

                  </span>
                                        </div> : ''}
                                    {/*<span class="input-error show">*비밀번호가 일치하지않습니다.</span> */}
                                </div>


                                <div className="input-component">
                                    <label className="required">이메일 주소</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="input-group__input_form"
                                            placeholder="이메일 주소를 입력해주세요."
                                            value={dataForm.email}
                                            onChange={_onChangeInput}
                                            name={'email'}
                                            autoComplete={'off'}
                                            // disabled={statusCheckEmail === 'done' ? true : false}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-register register-page__custom-button-register-page-disable"
                                            disabled={statusCheckEmail === 'done' ? true : false}
                                            onClick={() => _checkValidate('email')}
                                        >중복확인
                                        </button>
                                        <label className="note-email">
                                            * 가입한 이메일 주소는 로그인 아이디로 사용되며, 변경이 <br/>
                                            불가능합니다.
                                        </label>
                                    </div>
                                    {dataError.email ? <span className="input-error show">*{dataError.email}</span> : ''}
                                </div>


                                <div className="input-component">
                                    <label className="required">비밀번호</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            placeholder="영문/숫자 6자~20자 이내"
                                            name={'password'}
                                            maxLength="20"
                                            value={dataForm.password}
                                            onChange={_onChangeInput}
                                            autoComplete={'off'}
                                            className={dataForm.password ? 'register-page__password-asterisk' : ''}
                                        />
                                        <span
                                            className={'register-page__asterisk'}>{Array(dataForm.password.length).fill('*').join('')}</span>
                                    </div>
                                    {dataError.password ?
                                        <span className="input-error show">*{dataError.password}</span> : ''}
                                </div>
                                <div className="input-component">
                                    <label className="required">비밀번호 확인</label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            placeholder="영문/숫자 6자~20자 이내"
                                            name={'password_confirmation'}
                                            maxLength="20"
                                            value={dataForm.password_confirmation}
                                            onChange={_onChangeInput}
                                            autoComplete={'off'}
                                            className={dataForm.password_confirmation ? 'register-page__password-asterisk' : ''}
                                        />
                                        <span
                                            className={'register-page__asterisk'}>{Array(dataForm.password_confirmation.length).fill('*').join('')}</span>
                                    </div>
                                    {dataError.password_confirmation ?
                                        <span className="input-error show">*{dataError.password_confirmation}</span> : ''}

                                </div>
                                <label className="checkbox-component">
                                    <div className="checkbox">
                                        <input
                                            type="checkbox"
                                            checked={dataForm.agree}
                                            name={'agree'}
                                            value={dataForm.agree}
                                            onChange={_onChangeInput}
                                        />
                                        <span/>
                                    </div>
                                    <div className="label d-flex align-start">
                                        <h4 className="agree-terms unCheck">
                                            약관에 전체 동의합니다.
                                        </h4>
                                    </div>
                                </label>

                                {/*terms_of_service : false,*/}
                                {/*privacy_policy : false*/}
                                <label className="checkbox-component register-page__checkbox">
                                    <div
                                        className="checkbox"
                                    >
                                        <input
                                            type="checkbox"
                                            checked={dataForm.terms_of_service}
                                            name={'terms_of_service'}
                                            value={dataForm.terms_of_service}
                                            onChange={_onChangeInput}
                                        />
                                        <span></span>
                                    </div>
                                    <div className="check-box-agree-terms d-flex  justify-content-between">
                                        <h4 className="agree-terms unCheck checkbox-component__label ">서비스 이용약관(필수)</h4>
                                        <Link
                                            // to={ROUTERS.INFORMATION_TERM}
                                            // to={ROUTERS.INFORMATION_SERVICE_TERM}
                                            to={'#'}
                                            onClick={()=> handleChangePage('term')}
                                            className="label-agree-terms"
                                            // state={{
                                            //     dataForm,
                                            //     statusCheckEmail,
                                            //     statusCheckPhoneNumber
                                            // }}
                                        >
                                            약관보기
                                        </Link>
                                    </div>
                                </label>

                                <label className="checkbox-component register-page__checkbox">
                                    <div className="checkbox">
                                        <input
                                            type="checkbox"
                                            checked={dataForm.privacy_policy}
                                            name={'privacy_policy'}
                                            value={dataForm.privacy_policy}
                                            onChange={_onChangeInput}
                                        />
                                        <span></span>
                                    </div>
                                    <div className="check-box-agree-terms d-flex  justify-content-between">
                                        <h4 className="agree-terms unCheck checkbox-component__label ">개인정보 취급방침(필수)</h4>
                                        <Link
                                            to={'#'}
                                            onClick={()=> handleChangePage('policy')}
                                            className="label-agree-terms"
                                        >약관보기</Link>
                                    </div>
                                </label>

                                <button
                                    type="button"
                                    className={`btn btn-block btn-primary mt-5 mb-3 register-page__custom-button-register-page  register-page__custom-button-register-page-disable`} //${buttonSubmit ? '' : 'btn-register'}
                                    onClick={()=>_handleSubmitForm('email_confirm')} //email_confirm
                                    disabled={!buttonSubmit}
                                >
                                    회원가입
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <DialogComponent
                    id={"MD3"}
                    show={dialogMessages.show}
                    title={"알림"}
                    closeBtn={"확인"}
                    handleClose={_handleCloseDialog}
                >
                    <div className={'register-page__dialog-content'} dangerouslySetInnerHTML={contentDialog()}/>
                </DialogComponent>


                {/* popupConfirmRegisterEmail */}
                <DialogComponent
                  id={"MD4"}
                  show={popupConfirmRegisterEmail}
                  title={"알림"}
                  closeBtn={"취소"}
                  customBtn={"확인"}
                  bodyClassName="pl-0 pr-0"
                  handleClose={handleCancelRegister}
                  handleCustom={()=> _handleSubmitForm('register_confirm')}

                >
                    <p className="email-text ">{dataForm.email}<span className={'text-dark'}>으로</span> </p> 회원가입을 진행하시겠습니까?
                    <p className="warning-text mt-2">! 가입된 이메일 주소는 변경이 불가능합니다</p>
                </DialogComponent>


                <DialogComponent
                  id={"MD5"}
                  show={popupRegisterSubmit} //알림
                  title={"알림"}
                  closeBtn={"다음으로 이동"}
                  handleClose={()=> _handleSubmitForm('')} //register => home
                >
                    <div>
                        <div>
                            <p className={'p-0 m-0'} style={{fontWeight: 500}}>회원 가입이 완료되었습니다!</p>
                            {/*{
                                process.env.REACT_APP_DISABLED_VIDEO_MESSAGE === 'false' && <>
                                    <p className={'p-0 m-0 text-nowrap'}>감사의 의미로 <b>영상편지 1회 무료쿠폰</b>이</p>
                                    <p className={'p-0 m-0'}>지급되었으니 이용해보세요!</p>
                                </>
                            }*/}
                            
                        </div>
                        {/*{
                            process.env.REACT_APP_DISABLED_VIDEO_MESSAGE === 'false' && <>
                                <div className={'mt-3'}>
                                    <div className="coupon-card">
                                        <img className="coupon-card__bgr h-100" src="/images/signup_coupon_218_87.svg"/>
                                        <div className="coupon-card__content">
                                            <img className="coupon-card__content__icon" src="/images/icon_video_44_50.svg"/>
                                            <div className="coupon-card__content__text"><label className="coupon-card-text-title">영상편지<br/>1회 무료 쿠폰</label><label className="coupon-card-text-description">유효기간 : 무제한</label></div>
                                        </div>
                                        <div className="coupon-card__user-purchase"><label className="m-0 d-block">관리자 지급</label></div>
                                    </div>
                                </div>
                                <div className={'m-0 p-0 register-page__description-popup-register'}>쿠폰확인 : 선물함 > 쿠폰</div>
                            </>
                        }*/}
                    </div>

                </DialogComponent>



            </MainLayout>

            {typePage === 'term' ?
                <InfoService informationData={serviceTerm} title={'이용약관'} changePage={handleChangePage} />
                : <InfoService informationData={servicePolicy} title={'개인정보 처리방침'} changePage={handleChangePage} />}
        </>
    );
};

export default RegisterComponent;
